import { Button, Form, Input, Modal, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { toggleModal } from "../../../features/assignments/assignmentsSlice";
import { useAddAssignmentMarksMutation, useGetAssignmentMarksByStudentQuery } from "../../../features/assignmentMarks/assignmentMarksApi";
import { useEffect } from "react";


export default function AssignmentSubmitForm({ assignment }) {
  const { user } = useSelector(state => state.auth)
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const { openModal } = useSelector(state => state.assignments)

  const { data: submittedAssignments } = useGetAssignmentMarksByStudentQuery({ studentId: user?.id, title: assignment.title })
  const [addMark, { isLoading, isSuccess, isError, error }] = useAddAssignmentMarksMutation()
  console.info({ submittedAssignments })
  const submitHandler = (data) => {
    const body = {
      student_id: user.id,
      student_name: user.name,
      "assignment_id": assignment?.id,
      "title": assignment?.title,
      "createdAt": new Date().toISOString(),
      "totalMark": assignment?.totalMark,
      "repo_link": data.repo_link,
      "status": "pending"
    }

    addMark(body)
  }

  const cancelHandler = () => {
    dispatch(toggleModal(false));
    form.resetFields()
  }

  useEffect(() => {
    if (isSuccess) {
      cancelHandler();
    }
  }, [isSuccess])

  return (
    <>
      <Modal open={openModal} title={`Assignment : ${assignment?.title}`}
        centered
        footer={false}
        onCancel={cancelHandler}>
        {
          submittedAssignments?.length ?
            <div>
              <p>আপনি যা জমা দিয়েছেন।</p>
              <div>
                <p>Repo Link</p>
                <p>{submittedAssignments[0]?.repo_link}</p>
              </div>
            </div>
            :

            <Form onFinish={submitHandler} form={form} layout="vertical">
              <Form.Item label="Repository Link" name="repo_link" rules={[{ required: true, message: 'Repo link is required' }]}>
                <Input />
              </Form.Item>
              {isError &&
                <p p className="w-full text-center text-red-800">
                  {typeof error?.data == 'string' ? error.data : 'Internal server error'}
                </p>
              }
              <Form.Item className="flex justify-end">
                <Space>
                  <Button onClick={cancelHandler}>Cancel</Button>
                  <Button type="primary" htmlType="submit">Submit</Button>
                </Space>
              </Form.Item>
            </Form>
        }

      </Modal >
    </>
  )
}